// extracted by mini-css-extract-plugin
export var deliveryRow = "_oz-a";
export var fixedHeight = "_oz-4";
export var freightLogo = "_oz-9";
export var fullWidth = "_oz-3";
export var priceColumn = "_oz-5";
export var radioSelected = "_oz-7";
export var radioUnselected = "_oz-6";
export var selectedOption = "_oz-2";
export var selectedOptionContainer = "_oz-1";
export var selection = "_oz-0";
export var tallSkeletonText = "_oz-8";